export default ({children, hidden}) => (!hidden ? children : null);
